import { resizeImage, resizeImageSrcsetWidths } from './resizeImage';

const IMAGE_WIDTHS = [480, 720, 860, 1280, 1720, 2580] as const;
const escapeAttribute = (value: string, quote: string) =>
  value
    .replaceAll('&', '&amp;')
    .replaceAll(quote, quote === '"' ? '&quot;' : '&#39;');

/* Старые статьи хранятся как HTML и выводятся через v-html. */
export const resizeHtmlImages = (html: string): string =>
  html.replace(/<img\b[^>]*>/gi, (tag) => {
    const srcAttribute = /(^|\s)src\s*=\s*(["'])(.*?)\2/i.exec(tag);
    if (!srcAttribute) return tag;

    const [, prefix, quote, encodedUrl] = srcAttribute;
    if (!quote || !encodedUrl) return tag;

    const url = encodedUrl.replaceAll('&amp;', '&');
    const src = resizeImage(url, { width: 860 });
    if (src === url) return tag;

    let result = tag.replace(
      srcAttribute[0],
      `${prefix}src=${quote}${escapeAttribute(src, quote)}${quote}`,
    );

    const srcset = resizeImageSrcsetWidths(url, IMAGE_WIDTHS);
    const srcsetAttribute = /\ssrcset\s*=\s*(["'])(.*?)\1/i.exec(result);

    if (srcsetAttribute) {
      result = result.replace(
        srcsetAttribute[0],
        ` srcset="${escapeAttribute(srcset, '"')}"`,
      );
      if (!/\ssizes\s*=/i.test(result)) {
        result = result.replace(
          /\s*\/?>(?=$)/,
          ' sizes="(max-width: 900px) 100vw, 860px">',
        );
      }
    } else {
      result = result.replace(
        /\s*\/?>(?=$)/,
        ` srcset="${escapeAttribute(srcset, '"')}" sizes="(max-width: 900px) 100vw, 860px">`,
      );
    }

    return result;
  });
